import { render, staticRenderFns } from "./purchaQualityRecord.vue?vue&type=template&id=6687dfb1"
import script from "./purchaQualityRecord.vue?vue&type=script&lang=js"
export * from "./purchaQualityRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports